import request from "@/utils/request";

export default function agentGetWeChatUserByPhone(params) {
    return request({
        url: `/user/weChartUser/agentGetWeChatUserByPhone`,
        params: params
    })
}
